import {
  CONTRIBUTOR_PERMISSION_CHECK_TYPE,
  CONTRIBUTOR_VIEW_ACCESS,
  PERMISSION_TYPES,
} from '../../../../../constants/contributors';
import useContributorPermission from './useContributorPermission';

/**
 * Determines whether a user has view permissions based on their
 * contributor hierarchy.
 *
 * @param {Object} options The option list.
 * @param {String} options.entityId ID of the entity (Album or AlbumFolder) to check permission for.
 * @param {Array<CONTRIBUTOR_VIEW_ACCESS>} options.permissions List of dedicated view permissions to check for. These do *NOT* Require the type.
 * @param {String} options.checkType How to deal with provided permissions. Either Inclusive or exclusive.
 */
const useViewPermission = ({
  entityId,
  permissions = [CONTRIBUTOR_VIEW_ACCESS.ALL, CONTRIBUTOR_VIEW_ACCESS.OWN],
  checkType = CONTRIBUTOR_PERMISSION_CHECK_TYPE.ANY,
  ...opts
}) => {
  return useContributorPermission({
    entityId,
    permissions: permissions.map(permission => ({
      type: PERMISSION_TYPES.VIEW_ACCESS,
      permission,
    })),
    checkType,
    ...opts,
  });
};

export default useViewPermission;
